// The key upstack_api's PermissionSets::Capabilities::MAP registers for creating a service request, kept in step by hand.
export const ServiceRequestCapability = {
  CREATE: 'service_requests#create'
} as const;
